import React, { FC, useEffect, useMemo, useState, memo } from 'react';
import { useAuthFetchFromRestAPI } from '../../util/api';
import ChatMessageComponent from './ChatMessageComponent';
import ChatHeadComponent from './ChatHeadComponent';
import ChatHeadHorizontalComponent from './ChatHeadHorizontalComponent';
import { ChatHeadDto } from '../../../../shared/dtos/chat.dto';
import { useChat } from '../../contexts/chat-context';
import { sortByLatestDate } from '../../util/date-utils';

type Props = { therapist: any };

const ChatComponent: FC<Props> = ({ therapist }) => {
  const { authFetch } = useAuthFetchFromRestAPI();
  const { chatHeadMap } = useChat();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [therapies, setTherapies] = useState<ChatHeadDto[]>([]);
  const [selectedTherapy, setSelectedTherapy] = useState<ChatHeadDto | null>(null);

  const handelTherapySelection = (therapy: ChatHeadDto) => {
    setSelectedTherapy(therapy);
  };
  const handleResize = () => setIsMobile(window.innerWidth < 768);

  const sortedTherapies: ChatHeadDto[] = useMemo(
    () => sortByLatestDate(therapies, (therapy: ChatHeadDto) =>
      chatHeadMap.get(therapy.patientId)?.createdAt ?? therapy.lastMessageDate),
    [therapies, chatHeadMap],
  );

  useEffect(() => {
    async function load() {
      const response: ChatHeadDto[] = await authFetch<ChatHeadDto[]>('/api/v1/therapies/chat');
      setTherapies(response);
      setSelectedTherapy(response[0] ?? null);
    }

    window.addEventListener('resize', handleResize);
    void load();
  }, []);

  return (
    <div className="bg-white overflow-hidden d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
      {isMobile ?
        <ChatHeadHorizontalComponent
          therapies={sortedTherapies}
          selectedTherapy={selectedTherapy}
          handleSelectTherapy={handelTherapySelection}>
        </ChatHeadHorizontalComponent>
        : null}
      <div className="d-flex flex-grow-1" style={{ minHeight: 0 }}>
        {!isMobile ?
          <ChatHeadComponent
            therapies={sortedTherapies}
            selectedTherapy={selectedTherapy}
            handleSelectTherapy={handelTherapySelection}>
          </ChatHeadComponent> : null}
        {selectedTherapy ?
          <ChatMessageComponent
            key={selectedTherapy.id}
            therapy={selectedTherapy}
            therapist={therapist}
            isMobile={isMobile}>
          </ChatMessageComponent> : null}
      </div>
    </div>
  );

};

export default memo(ChatComponent);
